import { axios } from '../utilities/axios';
import { getRequestHeaders } from '../utilities/requestHeaders';

const baseUrl = '/account';

export default class AccountService {
  static logUserInUsingNewLogin(userCredentials) {
    const endpoint = '/user-login';
    return axios.post(endpoint, userCredentials);
  }

  static logUserIn(userCredentials) {
    const endpoint = `${baseUrl}/login`;
    return axios.post(endpoint, userCredentials);
  }

  static logUserOut() {
    const endpoint = `${process.env.CVNA_APP_KONG_URL}/core/user-orchestrator/api/v1/account/logout`;
    return axios.post(endpoint);
  }

  static logUserOutThroughUO() {
    const endpoint = '/user-logout';
    return axios.post(endpoint);
  }

  static logUserOutOfLegacyDotCom() {
    return axios.post(`${baseUrl}/logout`);
  }

  static createAccount(payload) {
    const headers = getRequestHeaders();

    const endpoint = `${process.env.CVNA_APP_KONG_URL}/core/user-orchestrator/api/v1/account/create`;
    return axios.post(endpoint, payload, { headers });
  }
}
